import { render, staticRenderFns } from "./decision_log_header_button.vue.js?vue&type=template&id=71181354&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./decision_log_header_button.vue?vue&type=template&id=71181354&vue3"
import script from "./decision_log_header_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./decision_log_header_button.vue?vue&type=script&lang=js&vue3"
export * from "./decision_log_header_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./decision_log_header_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports